"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[132],{

/***/ 3221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GarageProfileMap": function() { return /* binding */ GarageProfileMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5715);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2013);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(577);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5243);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(leaflet__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7762);
/* harmony import */ var _App_components_GarageList_Map_GarageListMap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7953);
/* harmony import */ var _App_public_assets_images_google_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4357);










var GarageProfileMap = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(GarageProfileMap, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(GarageProfileMap);
    function GarageProfileMap() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, GarageProfileMap);
        return _super.apply(this, arguments);
    }
    var _proto = GarageProfileMap.prototype;
    _proto.render = function render() {
        var garage = this.props.garage;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_leaflet__WEBPACK_IMPORTED_MODULE_9__/* .MapContainer */ .h, {
            center: {
                lat: garage ? garage.lat : 48.137154,
                lng: garage ? garage.lon : 11.576124
            },
            zoom: 11,
            scrollWheelZoom: false,
            style: {
                "width": "100%",
                "height": "100%"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_leaflet__WEBPACK_IMPORTED_MODULE_10__/* .TileLayer */ .I, {
                    subdomains: [
                        "mt0",
                        "mt1",
                        "mt2",
                        "mt3"
                    ],
                    maxZoom: 20,
                    attribution: '\xa9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                    url: "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_leaflet__WEBPACK_IMPORTED_MODULE_11__/* .Marker */ .J, {
                    position: [
                        garage ? garage.lat : 48.137154,
                        garage ? garage.lon : 11.576124
                    ],
                    icon: leaflet__WEBPACK_IMPORTED_MODULE_2___default().divIcon({
                        html: (0,react_dom_server__WEBPACK_IMPORTED_MODULE_3__/* .renderToStaticMarkup */ .uS)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_App_components_GarageList_Map_GarageListMap__WEBPACK_IMPORTED_MODULE_4__.MapLocationIcon, {}))
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "copyright absolute bottom-2 left-2 z-[9999]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: _App_public_assets_images_google_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
                        alt: "Google"
                    })
                })
            ]
        });
    };
    return GarageProfileMap;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
/* harmony default export */ __webpack_exports__["default"] = (GarageProfileMap);


/***/ })

}]);